/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Gallery {...cmsData} />)
 * and then make these props fit the final module.
 */
import React from "react"
import { Section } from "@bw/bits"
import { Gallery as GalleryModule } from "@bw/modules"
import { graphql } from "gatsby"

const Gallery = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  assets,
  anchor,
}) => {
  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition: buttonPosition?.value,
        anchor,
      }}
    >
      <GalleryModule images={assets} />
    </Section>
  )
}

export const query = graphql`
  fragment GalleryModuleFragment on GalleryModule {
    assets {
      alt
      has_focus
      focus_css
      localImage {
        childImageSharp {
          original {
            src
            width
            height
          }
          gatsbyImageData(width: 600)
        }
      }
    }
  }
`

export { Gallery }
